@let hasErrorValue = hasError();
@let hintValue = hint();
@let valueValue = value();

<rt-box layout-vertical [class.multi-line-field__box--invalid]="hasErrorValue">
  <rt-form-field>
    <rt-evaluation-field-label
      [title]="title()"
      [hint]="hintValue"
      [required]="required()"
      [filled]="!!valueValue"
    />

    <rt-textarea
      [formControl]="control()"
      [autoHeight]="true"
      [disableInvalidStyles]="true"
      [placeholder]="'app.evaluation_panel.your_answer' | translate"
      margin-top-small-x
    />
  </rt-form-field>
</rt-box>

@if (hasErrorValue) {
  <div class="multi-line-field__error">
    {{ 'app.evaluation_panel.errors.basic_required' | translate }}
  </div>
}
